module.exports = require('./helpers/bundle-url').getBundleURL('lly8x') + "editgig.b2d67b69.gif" + "?" + Date.now();